(function ($) {
	$(document).ready(function () {
		$(".slide-product__inner").slick({
			infinite: true,
			slidesToShow: 3,
			arrows: true,
			dots: false,
			autoplay: true,
			speed: 5000,
			autoplaySpeed: 1000,
			centerMode: true,
			pauseOnHover: false,
			prevArrow:
				'<span class="swiper-button-prev"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 26 50.9" xml:space="preserve"><polyline points="25.6,0.4 0.7,25.5 25.6,50.6 "></polyline></svg></span>',
			nextArrow:
				'<span class="swiper-button-next"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 26 50.9" xml:space="preserve"><polyline points="0.4,50.6 25.3,25.5 0.4,0.4 "></polyline></svg></span>',
			responsive: [
				{
					breakpoint: 1024,
					settings: {
						slidesToShow: 2,
						centerMode: true,
					},
				},
				{
					breakpoint: 600,
					settings: {
						slidesToShow: 1,
						centerMode: false,
					},
				},
				{
					breakpoint: 480,
					settings: {
						slidesToShow: 1,
						centerMode: false,
					},
				},
				// You can unslick at a given breakpoint now by adding:
				// settings: "unslick"
				// instead of a settings object
			],
		});
	});
	jQuery(document).ready(function ($) {
		$(".countdown-timercm").each(function () {
			var countdownElement = $(this);
			var targetDate = countdownElement.data("datecm");

			if (targetDate) {
				var countdownDate = new Date(targetDate).getTime();

				var x = setInterval(function () {
					var now = new Date().getTime();
					var distance = countdownDate - now;

					var days = Math.floor(distance / (1000 * 60 * 60 * 24));
					var hours = Math.floor(
						(distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
					);
					var minutes = Math.floor(
						(distance % (1000 * 60 * 60)) / (1000 * 60)
					);
					var seconds = Math.floor((distance % (1000 * 60)) / 1000);

					// Pad values with leading zeros if necessary
					days = String(days).padStart(2, "0");
					hours = String(hours).padStart(2, "0");
					minutes = String(minutes).padStart(2, "0");
					seconds = String(seconds).padStart(2, "0");

					countdownElement.html(`
						<ul  class="cm-countdown-items">
							<li class="cm-countdown-item">
								<div class="cm-countdown-days">
									<span data-days="" class="cm-countdown-digits">${days}</span>
									<span class="cm-countdown-label">Days</span>
								</div>
							</li>
							<li class="cm-countdown-item">
								<div class="cm-countdown-hours">
									<span data-hours="" class="cm-countdown-digits">${hours}</span>
									<span class="cm-countdown-label">Hours</span>
								</div>
							</li>
							<li class="cm-countdown-item">
								<div class="cm-countdown-minutes">
									<span data-minutes="" class="cm-countdown-digits">${minutes}</span>
									<span class="cm-countdown-label">Minutes</span>
								</div>
							</li>
							<li class="cm-countdown-item">
								<div class="cm-countdown-seconds">
									<span data-seconds="" class="cm-countdown-digits">${seconds}</span>
									<span class="cm-countdown-label">Seconds</span>
								</div>
							</li>
						</ul>
					`);

					if (distance < 0) {
						clearInterval(x);
						countdownElement.html("EXPIRED");
					}
				}, 1000);
			}
		});
	});
})(jQuery);